import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shared-info',
  templateUrl: './shared-info.component.html',
  styleUrls: ['./shared-info.component.scss'],
})
export class SharedInfoComponent {
  @Input() label?: string;
  @Input() value?: string;
}
